module.exports = require('./lib/linkify-element')["default"];